<template>
  <div>
    <el-table
      v-bind:data="displayVitalType"
      :show-header="false"
      row-key="id"
      @row-click="selectRow"
      :expand-row-keys="expand"
      empty-text="No vitals recorded"
      style="width: 100%"
    >
      <!-- Expandable message history list -->
      <el-table-column type="expand">
        <template slot-scope="scope">
          <SleepAnalyis
            v-if="scope.row.id === 'sleep'"
            :event-list="scope.row.event"
          >
          </SleepAnalyis>
          <VitalAnalysis v-else :vital="scope.row.id" :event="scope.row.event">
          </VitalAnalysis>
        </template>
      </el-table-column>

      <el-table-column width="50">
        <template slot-scope="scope">
          <img
            class="vital-icon"
            :src="'https://cdn.doctorbox.com/vital/' + scope.row.id + '.png'"
          />
        </template>
      </el-table-column>

      <el-table-column prop="title" width="250">
        <template slot-scope="scope">
          <div style="line-height:16px">
            <strong>{{ scope.row.title }}</strong
            ><br />
          </div>
        </template>
      </el-table-column>

      <el-table-column width="110">
        <template slot-scope="scope">
          <span class="times-count">{{
            formatCount(scope.row.event.length, "time")
          }}</span>
        </template>
      </el-table-column>

      <el-table-column width="300">
        <template slot-scope="scope">
          <div
            v-if="scope.row.id === 'blood_pressure'"
            style="line-height:18px"
          >
            Systolic <strong>{{ systolic(scope.row.min[0]) }}</strong>
            <template
              v-if="systolic(scope.row.max[0]) != systolic(scope.row.min[0])"
            >
              to <strong>{{ systolic(scope.row.max[0]) }}</strong>
            </template>
            mmHg
            <br />
            Diastolic <strong>{{ diastolic(scope.row.min[1]) }}</strong>
            <template
              v-if="diastolic(scope.row.max[1]) != diastolic(scope.row.min[1])"
            >
              to <strong>{{ diastolic(scope.row.max[1]) }}</strong>
            </template>
            mmHg
          </div>
          <div v-else-if="scope.row.id === 'sleep'" style="line-height:18px">
            Avg <strong> {{ scope.row.avg }} hrs</strong> sleep/day<br />Min
            <strong
              >{{ getHrMnForDay(scope.row.min.value * 3600000) }} hrs</strong
            >
            , Max
            <strong
              >{{ getHrMnForDay(scope.row.max.value * 3600000) }} hrs</strong
            >
          </div>
          <div v-else style="line-height:18px">
            <template
              v-if="
                formatValue(scope.row.min.value, scope.row.min.unit) !=
                  formatValue(scope.row.max.value, scope.row.max.unit)
              "
            >
              <span
                v-html="
                  formatValue(scope.row.min.value, scope.row.min.unit, true)
                "
              ></span>
              to
              <span
                v-html="formatValue(scope.row.max.value, scope.row.max.unit)"
              ></span>
            </template>
            <template v-else>
              <span
                v-html="formatValue(scope.row.min.value, scope.row.min.unit)"
              ></span>
            </template>
            <!-- <span style="font-size:12px;color:#5f5f5f;">
						{{ formatDate(scope.row.min.time) }} &middot; {{ formatTime(scope.row.min.time) }}
					</span> -->
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column width="200">
			<template slot-scope="scope">
				{{ formatTime(scope.row.event.find((s) => s.id == patient.last_event['vital:' + scope.row.id]).time) }}
			</template>
		</el-table-column> -->

      <!-- <el-table-column>
			<template slot-scope="scope">
				<DateRange :row="scope.row"></DateRange>
			</template>
		</el-table-column> -->

      <el-table-column width="220">
        <template slot-scope="scope">
          <DateRange
            :row="scope.row"
            :patient="patient"
            :type="'vital:' + scope.row.id"
          ></DateRange>
        </template>
      </el-table-column>

      <el-table-column fixed="right">
        <template slot-scope="scope">
          <div style="text-align:right">
            <!-- {{ scope.row.event[scope.row.event.length - 1].value }} -->
          </div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" width="50">
        <template slot-scope="scope">
          <div style="margin-top: 10px;">
            <img
              v-if="expand.length && expand[0] === scope.row.id"
              src="../../images/up-arrow.png"
              width="21px"
              height="21px"
            />
            <img
              v-else
              src="../../images/down-arrow.png"
              width="21px"
              height="21px"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="show-more" v-if="showRows < vitalType.length">
      <el-button type="text" @click="showMore">
        {{ showMoreText }}&nbsp;<i class="el-icon-arrow-down"></i>
      </el-button>
    </div>
    <div class="show-more" v-if="showRows >= vitalType.length && this.showLess">
      <el-button type="text" @click="showLessHandler">
        {{ showLessText }}&nbsp;<i class="el-icon-arrow-up"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import CardTable from "../component/table";
import VitalGraph from "../../graph/type/Vital";
import VitalAnalysis from "./analysis/Analysis";
import SleepAnalyis from "./analysis/SleepAnalysis";

import formatValue from "./format/format-value";

import { getHrMnForDay } from "./analysis/util";

const VITAL_NAME = {
  body_weight: "Weight",
  heart_rate: "Heart Rate",
  blood_pressure: "Blood Pressure",
  stress: "Stress",
  body_temperature: "Temperature",
  blood_glucose: "Blood Sugar",
  mood: "Mood",
  sleep: "Sleep",
};

export default {
  name: "patient-vital-card-table",
  extends: CardTable,

  props: {
    patient: {
      type: Object,
      required: true,
    },
    vitals: {
      type: Array,
    },
  },

  data() {
    return {
      edit: false,
      expand: [],
      showLess: false,
      showRows: 3,
    };
  },

  methods: {
    formatValue,
    getHrMnForDay,
    selectRow(row, a, b) {
      if (this.expand[0] == row.id) this.expand = [];
      else this.expand = [row.id];
    },
    showMore() {
      this.showLess = true;
      this.showRows += 10;
    },
    showLessHandler() {
      this.showLess = false;
      this.showRows = 3;
    },
    maxBloodPressure(events) {
      var maxSys = null,
        maxDia = null;
      events.forEach((event) => {
        if (maxSys == null || this.compareSystolic(maxSys, event) < 0)
          maxSys = event;
        if (maxDia == null || this.compareDiastolic(maxDia, event) < 0)
          maxDia = event;
      });
      return [maxSys, maxDia];
    },
    minBloodPressure(events) {
      var minSys = null,
        minDia = null;
      events.forEach((event) => {
        if (minSys == null || this.compareSystolic(minSys, event) > 0)
          minSys = event;
        if (minDia == null || this.compareDiastolic(minDia, event) > 0)
          minDia = event;
      });
      return [minSys, minDia];
    },
    systolic(event) {
      return Math.round((event.value >> 16) & 0xffff);
    },
    diastolic(event) {
      return Math.round(event.value & 0xffff);
    },
    compareSystolic(a, b) {
      return ((a.value >> 16) & 0xffff) - ((b.value >> 16) & 0xffff);
    },
    compareDiastolic(a, b) {
      return (a.value & 0xffff) - (b.value & 0xffff);
    },
    compareEvent(a, b) {
      if (a.unit == null || b.unit == null || a.unit == b.unit)
        return a.value - b.value;

      let av = a.value,
        bv = b.value;
      // Convert celsius to fahrenheit
      if (a.unit == 5) av = av * 1.8 + 32;
      if (b.unit == 5) bv = bv * 1.8 + 32;
      // Convert kg to lb
      if (a.unit == 2) av = av * 2.20462;
      if (b.unit == 2) bv = bv * 2.20462;
      // Return the value difference
      return av - bv;
    },
    maxEvent(events) {
      var max = null;
      events.forEach((event) => {
        if (max == null || this.compareEvent(event, max) > 0) max = event;
      });
      return max;
    },
    minEvent(events) {
      var min = null;
      events.forEach((event) => {
        if (min == null || this.compareEvent(event, min) < 0) min = event;
      });
      return min;
    },
    /**
     * Calculating average sleep daywise
     * @param {[*]}
     */
    avgSleep(events) {
      // Adding sleeptime for the day at key values
      const lastNDaysSleep = events.reduce((dayAcc, event) => {
        const sleepDate = new Date(event.sleep_start).toLocaleDateString();
        dayAcc[sleepDate] =
          (dayAcc[sleepDate] ? dayAcc[sleepDate] : 0) +
          event.sleep_end -
          event.sleep_start;
        return dayAcc;
      }, {});

      /**
       * Filtered array of non zero days
       * @type {[Number]}
       */
      const nonZeroSleep = Object.values(lastNDaysSleep).filter(
        (sleepTime) => sleepTime !== 0
      );
      if (nonZeroSleep.length === 0) return 0;
      return (
        nonZeroSleep.reduce((sleepAcc, sleep) => sleepAcc + sleep, 0) /
        nonZeroSleep.length
      );
    },
  },

  computed: {
    vitalType() {
      var type = {};
      this.vitals.forEach((vital) => {
        let t = vital.type.split(":")[1];
        if (!type[t])
          type[t] = {
            id: t,
            title: VITAL_NAME[t] || t,
            event: [],
          };

        // TEMP: sleep/mood
        if (t == "sleep") {
          Vue.set(
            vital,
            "value",
            (vital.sleep_end - vital.sleep_start) / 3600000
          );
          Vue.set(vital, "unit", 8);
        } else if (t == "mood") {
          Vue.set(vital, "value", vital.mood);
          Vue.set(vital, "unit", 9);
        } else if (t == "heart_rate") Vue.set(vital, "unit", 1);
        else if (t == "blood_pressure") Vue.set(vital, "unit", 0);

        type[t].event.push(vital);
      });
      return Object.keys(type).map((t) => {
        let events = type[t].event.sort((a, b) => a.id.localeCompare(b.id));
        type[t].event = events;
        type[t].last = events[events.length - 1];

        // Get the min
        type[t].min =
          t === "blood_pressure"
            ? this.minBloodPressure(events)
            : this.minEvent(events);
        type[t].max =
          t === "blood_pressure"
            ? this.maxBloodPressure(events)
            : this.maxEvent(events);

        if (t === "sleep") {
          const avgSleepTime = this.avgSleep(events);
          type[t].avg = getHrMnForDay(avgSleepTime);
        }

        return type[t];
      });
    },
    displayVitalType() {
      return this.vitalType.slice(0, this.showRows);
    },
    schedule() {
      return this.getPatientSchedule(this.patient.id);
    },
    loading() {
      return this.getPatientLoadingState(this.patient.id);
    },
    showMoreText() {
      return "Show more";
    },
    showLessText() {
      return "Show less";
    },
  },

  components: {
    VitalGraph,
    VitalAnalysis,
    SleepAnalyis,
  },
};
</script>

<style lang="scss" scoped>
.show-more {
  .el-button, .el-button:hover, .el-button:focus {
    display: block;
    width: 100%;
    font-size: 14px;
    color: #4a9bf9;
    font-weight: 600;
  }
  .el-icon-arrow-down {
    font-weight: 700;
  }
}
.vital-icon {
  width: 32px !important;
  height: 32px !important;
  float: left;
}
</style>
